var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-page"},[(_vm.pagedata && _vm.pagedata.attributes)?_c('header-intro',{attrs:{"title":_vm.pagedata.attributes.title,"banner":this.bannerimg}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }